// extracted by mini-css-extract-plugin
export var avatar = "_ri-3";
export var avatarContainer = "_ri-2";
export var avatarSpacer = "_ri-5";
export var avatarSpacerContainer = "_ri-4";
export var avatarStackContainer = "_ri-1";
export var bubble = "_ri-0";
export var remainderBubble = "_ri-6";